import React from 'react';

export function WaveDivider({ from = '#ffffff', to = '#f4f7fb', flip = false, height = 80 }) {
    return (
        <div
            aria-hidden="true"
            style={{ background: from, lineHeight: 0, transform: flip ? 'scaleY(-1)' : 'none' }}
        >
            <svg viewBox="0 0 1440 80" width="100%" height={height} preserveAspectRatio="none">
                <path
                    d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
                    fill={to}
                />
            </svg>
        </div>
    );
}
